import { Suspense, lazy, useEffect } from "react";
import { LazyMotion, MotionConfig, domAnimation } from "framer-motion";
import { useIsMobileLayout } from "@/useMedia";
import { useStore } from "@/world/store";
import { syncContent } from "@/world/content";

const DesktopApp = lazy(() => import(/* webpackChunkName: "desktop" */ "@/DesktopApp"));
const MobileApp = lazy(() => import(/* webpackChunkName: "mobile" */ "@/mobile/MobileApp"));
// The admin panel is only downloaded when you actually open it.
const AdminApp = lazy(() => import(/* webpackChunkName: "admin" */ "@/admin/AdminApp"));

function AdminHost() {
  const open = useStore((s) => s.adminOpen);
  return open ? (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={domAnimation}>
        <Suspense fallback={null}>
          <AdminApp />
        </Suspense>
      </LazyMotion>
    </MotionConfig>
  ) : null;
}

export default function App() {
  const mobile = useIsMobileLayout();

  // Pull the latest edited content from the backend without blocking first paint.
  useEffect(() => {
    syncContent();
  }, []);

  return (
    <>
      <Suspense fallback={null}>{mobile ? <MobileApp /> : <DesktopApp />}</Suspense>
      <AdminHost />
    </>
  );
}
